'use strict';

export default angular
  .module('maestro.directives.common.date-picker', [])

  .directive('datePicker',
    /**
     * air-datePicker
     *
     * @scope ngModel {object|ngModel} object or scope
     * @scope options {object} air-datePicker options
     * @scope ms {boolean} use ngModel as date in ms(integer value) instead of Date object
     *
     * @example
     * <input date-picker type="text" readonly options="{language: 'en'}" ng-model="date">
     * <input date-picker ms type="text" readonly options="options" ng-model="dateInMs">
     */
    function() {
      return {
        restrict: 'A',
        require: '?ngModel',
        scope: {
          options: '&',
          ngModel: '=?',
          toggleButton: '='
        },
        link: function(scope, element, attrs, ngModelCtrl) {
          let currentDate;
          let currentFormattedDate;
          let observer;
          let defaults = {
            language: 'en',
            onShow: function(dp, animationCompleted) {
              if (!animationCompleted) {
                // Original input visibility
                let inputVisibility = dp.$el.is(':visible');
                if (scope.toggleButton && scope.toggleButton[0] && !inputVisibility) {
                  // Get position of the toggle button
                  let position = scope.toggleButton[0].getBoundingClientRect();
                  // Set position for the datepicker DOM element
                  let datepicker = dp.$datepicker[0];
                  relocateElement(position, datepicker);

                  // Fix issue with auto-hiding of the datepicker
                  $(window).on('resize', onWindowResize);

                  observer = new MutationObserver(() => {
                    relocateElement(position, datepicker);
                  });
                  observer.observe(datepicker, {
                    attributeFilter: ['style'],
                  });

                }
              } else {
                scope.isDatepickerActive = true;
              }
            },
            onHide: function(dp, animationCompleted) {
              if (animationCompleted) {
                scope.isDatepickerActive = false;
              }
              observer?.disconnect();
              observer = undefined;
              $(window).off('resize', onWindowResize);
            }
          };

          if (ngModelCtrl) { // Don't do anything unless we have a model
            ngModelCtrl.$parsers.push(function(value) { // value from inside of input (String)
              // actually we should parse text values from here and call $(element).data('datepicker').selectDate(newDate);
              // now we just ignoring the text input
              return scope.ngModel;
            });
            ngModelCtrl.$formatters.push(function(value) { // value from outside (Date)
              return currentFormattedDate;
            });
          }

          // Model to view
          scope.$watch('ngModel', function(newVal, oldVal) {
            if (!newVal) {
              $(element).data('datepicker').clear();
              return;
            }

            let newDate;
            if (angular.isDate(newVal)) { // if date object
              newDate = newVal;
            } else if (Number.isInteger(newVal) && newVal > 0) { // if ms
              newDate = new Date(newVal);
            } else if (angular.isArray(newVal) && (scope.options().multipleDates || scope.options().range)) {
              newDate = [];
              newVal.forEach(d => {
                if (angular.isDate(d)) { // if date object
                  newDate.push(d);
                } else if (Number.isInteger(d) && d > 0) { // if ms
                  newDate.push(new Date(d));
                } else {
                  return;
                }
              });
              // Compare two arrays
              if (JSON.stringify(newDate) === JSON.stringify(currentDate)) {
                return;
              }
              $(element).data('datepicker').selectDate(newDate);
              return;
            } else {
              return;
            }

            if (newDate === currentDate || (currentDate && newDate && currentDate.getTime && newDate.getTime && newDate.getTime() === currentDate.getTime())) {
              return;
            }
            $(element).data('datepicker').selectDate(newDate);
          });

          // Destroy datepicker instance
          scope.$on('$destroy', () => {
            let datepicker = $(element).datepicker().data('datepicker');
            datepicker.destroy();

            observer?.disconnect();
            $(window).off('resize', onWindowResize);
          });

          // Initialize
          scope.$watch(() => scope.options(), updateOptions, true);
          initOptions(scope.options());

          // View to model
          function onSelect(formattedDate, date, inst) {
            let onSelectCustom = this.onSelectCustom;
            scope.$applyAsync(function() {
              // fixing bug with plain value instead of array in range mode
              if (date && !angular.isArray(date) && inst.opts.range) {
                date = [date];
              }

              if (date && !angular.isArray(date) && inst.opts.correctValueToMinMax) {
                if (inst.minDate && date < inst.minDate) {
                  date = new Date(inst.minDate.getTime());
                  if (inst.date && inst.date.getTime() !== date.getTime()) {
                    inst.selectDate(date);
                  }
                }
                if (inst.maxDate && date > inst.maxDate) {
                  date = new Date(inst.maxDate.getTime());
                  if (inst.date && inst.date.getTime() !== date.getTime()) {
                    inst.selectDate(date);
                  }
                }
              }

              currentFormattedDate = formattedDate;
              if (currentDate === date) {
                return;
              }
              currentDate = date;
              setNgModel(date);

              if (onSelectCustom && angular.isFunction(onSelectCustom)) {
                onSelectCustom.call(this, formattedDate, date, inst);
              }
            });
          }

          function setNgModel(date) {
            if (angular.isArray(date)) {
              let model = [];
              date.forEach(d => {
                if ('ms' in attrs) { // if we have ms attribute we should expose MS instead of date
                  model.push(d ? d.getTime() : null);
                } else {
                  model.push(d);
                }
              });
              scope.ngModel = model;
            } else {
              if ('ms' in attrs) { // if we have ms attribute we should expose MS instead of date
                scope.ngModel = date ? date.getTime() : null;
              } else {
                scope.ngModel = date;
              }
            }
            scope.$applyAsync();
          }

          function updateOptions(options, oldOptions) {
            if (!options) {
              return false;
            }
            $(element).data('datepicker').update(fixOptions(options));
          }

          function initOptions(options) {
            $(element).datepicker(angular.extend(defaults, fixOptions(options)));

            // Toggle datepicker with optional toggle button
            if (scope.toggleButton && scope.toggleButton[0]) {
              scope.toggleButton.on('click', function() {
                let dp = $(element).datepicker().data('datepicker');
                if (!scope.isDatepickerActive) {
                  dp.show();
                } else {
                  dp.hide();
                }
              });
            }
          }

          function fixOptions(options) {
            let config = options ? angular.extend({}, defaults, options) : angular.copy(defaults);
            if (config.onSelect && config.onSelect !== onSelect) {
              config.onSelectCustom = config.onSelect;
            }
            config.onSelect = onSelect;

            if (config.minDate) {
              let minDate = new Date(config.minDate);
              minDate.setSeconds(0); // dropping seconds/milliseconds to handle properly some bugs
              minDate.setMilliseconds(0);
              config.minDate = minDate;
            }
            if (config.maxDate) {
              let maxDate = new Date(config.maxDate);
              maxDate.setSeconds(0);
              maxDate.setMilliseconds(0);
              config.maxDate = maxDate;
            }
            return config;
          }

          function relocateElement(position, el) {
            const newStyle = `left: ${position.left}px; top: ${position.top + position.height + 15}px`;
            if (newStyle !== el.getAttribute('style')) {
              el.setAttribute('style', newStyle);
            }
          }

          function onWindowResize() {
            const position = scope.toggleButton?.[0]?.getBoundingClientRect();
            const dp = $(element).data('datepicker');
            const datepicker = dp?.$datepicker?.[0];
            if (position && datepicker) {
              relocateElement(position, datepicker);
              dp.hide();
            }

          }
        }
      };
    })

  .name;
